// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShoppingFilledSvg from "@ant-design/icons-svg/es/asn/ShoppingFilled";
import AntdIcon from '../components/AntdIcon';

var ShoppingFilled = function ShoppingFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingFilledSvg
  }));
};

ShoppingFilled.displayName = 'ShoppingFilled';
export default /*#__PURE__*/React.forwardRef(ShoppingFilled);